import { useEffect, useState } from "react";
import axios from "axios";
import "../../.csscode/PopUpModal.css";
import { FormGroup, Label } from "reactstrap";
import Select from "react-select";
import { toast } from "sonner";
import SucessModal from "../successModal/SuccessModal";
import CustomLoader from "../static/CustomLoader";

const Chapter = ({ selectedId, mode, onHide, setRefresh, divData }) => {
  const apiUrl = localStorage.getItem("apiUrl");
  const dbTokenData = localStorage.getItem("dbTokenData");
  const headers = {
    Authorization: `Bearer ${dbTokenData}`,
    "Content-Type": "application/json",
    dbMaster: "",
  };
  const [id, setId] = useState("");
  const [code, setCode] = useState("");
  const [chapter, setChapter] = useState("");
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [divcode, setDivcode] = useState(0);
  const [selectedEmployees, setSelectedEmployees] = useState([]);
  const [employeeData, setEmployeeData] = useState([]);
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [ShowSucessModal, setShowSucessModal] = useState(false);
  const [SucessMessage, setSucessMessage] = useState("");
  const [titile, setTitle] = useState("");

  const handleCloseSucessModal = () => {
    setShowSucessModal(false);
    setSucessMessage("");
    setTitle("");
    onHide();
    setRefresh(true);
  };

  useEffect(() => {
    const fetchEmployeeData = async () => {
      try {
        const response = await axios.get(`${apiUrl}employee`, { headers });
        const employees = response.data.map((emp) => ({
          value: emp.code,
          label: `${emp.name} (${emp.code})`,
        }));
        setEmployeeData(employees);
      } catch (error) {
        toast.error("Failed to fetch employee data.");
      }
    };

    fetchEmployeeData();
  }, []);

  useEffect(() => {
    if (mode === "U" && selectedId && employeeData.length > 0) {
      const fetchChapterData = async () => {
        setLoading(true);
        try {
          const response = await axios.get(
            `${apiUrl}chapter/id/${selectedId}`,
            { headers },
          );
          const data = response.data;
          if (data.cd === 1) {
            toast.info(data.description);
          } else {
            setId(data.id);
            setCode(data.code);
            setChapter(data.chapter);
            setName(data.name);
            setDescription(data.description);
            setDivcode(data.divcode);

            if (data.empcodes) {
              const empCodes = data.empcodes
                .split(",")
                .map((code) => parseInt(code.trim()));
              const selectedEmps = employeeData.filter((emp) =>
                empCodes.includes(emp.value),
              );
              setSelectedEmployees(selectedEmps);
            }
          }
        } catch (error) {
          toast.error("Failed to fetch details.");
        } finally {
          setLoading(false);
        }
      };

      fetchChapterData();
    }
  }, [mode, selectedId, employeeData]);

  function clearFields() {
    setId("");
    setCode("");
    setChapter("");
    setName("");
    setDescription("");
    setDivcode(0);
    setSelectedEmployees([]);
  }

  const handleFocus = (field) => {
    setErrors((prevErrors) => ({ ...prevErrors, [field]: "" }));
  };

  const validateFields = () => {
    let errors = {};
    if (!chapter) errors.chapter = "Chapter is required...";
    if (!name) errors.name = "Name is required...";
    return errors;
  };

  const handleEmployeeChange = (selected) => {
    if (!selected) {
      setSelectedEmployees([]);
      return;
    }

    const uniqueEmployees = selected.filter(
      (emp, index, self) =>
        index === self.findIndex((e) => e.value === emp.value),
    );

    setSelectedEmployees(uniqueEmployees);
  };

  const getEmployeeCodesCSV = () => {
    return selectedEmployees.map((emp) => emp.value).join(",");
  };

  const handleAdd = async () => {
    try {
      const response = await axios.post(
        `${apiUrl}chapter`,
        {
          chapter,
          name,
          description,
          divcode,
          empcodes: getEmployeeCodesCSV(),
        },
        { headers },
      );

      if (response.data.cd === 1) {
        setSucessMessage(response.data.description);
        setTitle("⚠️ Failed");
      } else {
        setSucessMessage(response.data.description);
        setTitle("✔️ Success");
      }
      setShowSucessModal(true);
    } catch (error) {
      toast.error("Something went wrong while adding data.");
    } finally {
      setLoading(false);
    }
  };

  const handleUpdate = async () => {
    try {
      const response = await axios.put(
        `${apiUrl}chapter/${selectedId}`,
        {
          id,
          code,
          chapter,
          name,
          description,
          divcode,
          empcodes: getEmployeeCodesCSV(),
        },
        { headers },
      );
      if (response.data.cd === 1) {
        setSucessMessage(response.data.description);
        setTitle("⚠️ Failed");
      } else {
        setSucessMessage(response.data.description);
        setTitle("✔️ Success");
      }
      setShowSucessModal(true);
    } catch (error) {
      toast.error("Something went wrong while updating data.");
    } finally {
      setLoading(false);
    }
  };

  const handlesubmit = async () => {
    setLoading(true);

    const fieldErrors = validateFields();
    setErrors(fieldErrors);

    if (Object.keys(fieldErrors).length > 0) {
      toast.error("Please correct all required input fields.");
      setLoading(false);
      return;
    }

    if (mode === "A") {
      await handleAdd();
    } else {
      await handleUpdate();
    }
  };

  const customStyles = {
    placeholder: (provided) => ({
      ...provided,
      fontWeight: "normal",
      color: "#999",
    }),
    control: (provided) => ({
      ...provided,
      fontWeight: "normal",
      minHeight: "calc(1.5em + .75rem + 2px)",
    }),
    menu: (provided) => ({
      ...provided,
      zIndex: 9999,
    }),
    menuPortal: (provided) => ({
      ...provided,
      zIndex: 9999,
    }),
  };

  const renderForm = () => (
    <>
      <SucessModal
        show={ShowSucessModal}
        onClose={handleCloseSucessModal}
        headerText={titile}
        message={SucessMessage}
      />

      <div className="popupmodal-maindiv">
        <form>
          <FormGroup>
            <Label for="chapter">Chapter</Label>
            <input
              type="text"
              className={`form-control ${errors.chapter ? "is-invalid" : ""}`}
              value={chapter}
              onChange={(e) => setChapter(e.target.value)}
              onFocus={() => handleFocus("chapter")}
              placeholder="Enter Chapter"
            />
            {errors.chapter && (
              <div className="invalid-feedback">{errors.chapter}</div>
            )}
          </FormGroup>

          <FormGroup>
            <Label for="name">Name</Label>
            <input
              type="text"
              className={`form-control ${errors.name ? "is-invalid" : ""}`}
              value={name}
              onChange={(e) => setName(e.target.value)}
              onFocus={() => handleFocus("name")}
              placeholder="Enter Name"
            />
            {errors.name && (
              <div className="invalid-feedback">{errors.name}</div>
            )}
          </FormGroup>

          <FormGroup>
            <Label for="employees">Employees</Label>
            <Select
              options={employeeData}
              styles={customStyles}
              isMulti
              isClearable
              menuPortalTarget={document.body}
              menuPosition="fixed"
              value={selectedEmployees}
              onChange={handleEmployeeChange}
              placeholder="Select Employees (Optional)"
              noOptionsMessage={() => "No employees found"}
            />
            {selectedEmployees.length > 0 && (
              <small className="text-muted">
                Selected: {selectedEmployees.length} employee(s)
              </small>
            )}
          </FormGroup>
        </form>
        <div className="bottombtn">
          <button
            className="btn btn-success"
            disabled={loading}
            onClick={handlesubmit}
          >
            Save
          </button>
          <button className="btn btn-danger" onClick={clearFields}>
            Reset
          </button>
        </div>
        {loading && <CustomLoader />}
      </div>
    </>
  );

  if (mode === "A" || mode === "U") {
    return renderForm();
  }

  return null;
};

export default Chapter;
